// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"MenuItem__menuItem__3zEEF","title":"MenuItem__title__1gdiw","selected":"MenuItem__selected__6evOx","inline":"MenuItem__inline__whSIZ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/MenuItem/MenuItem.scss
// module id = 1289
// module chunks = 0